﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { deleteEstatesParent, getEstatesParent, getEstatesParents, saveEstatesParent } from "@/api/Maintainers/estatesParents";

const key = "estates_parents";

export function useEstatesParent(selected) {
	return useQuery([key, selected], () => selected && getEstatesParent({ slug: selected }));
}

export function useEstatesParentsPaginate(params) {
	return useQuery([key, params], () => getEstatesParents(params));
}

export function useMutateEstatesParent(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveEstatesParent, {
		onSuccess: (response) => {
			const estates_parents = _.omit(response, "detail");
			const estates_parent = _.omit(response, key);

			queryClient.setQueryData([key, String(estates_parent.detail.slug)], estates_parent);
			queryClient.setQueryData([key, params], estates_parents);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/configuracion/grupos_campos");
		},
	});
}

export function useMutateDeleteEstatesParent(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteEstatesParent, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
